import * as Html from "../../util/Html.ts";
import Icons from "../../svg/Icons.ts";

Html.registerWidget('widget/form/checkbox-master',{init:init})

function init(elem){
  elem.css('cursor','pointer')
  let 
    icon = elem.find("icon").first(),
    subcheckboxes = elem.parent().find('input[type="checkbox"]'),
    checked = subcheckboxes.filter(':not(:checked)').length===0;
  
  function refreshDisplay(){
    icon.html(checked?Icons.ic_checked.toString():Icons.ic_checkbox.toString());
  }
  elem.get(0).addEventListener('click',function(event){
    if(event.target.closest('[data-fw-onclick]')) {
      return;
    }
    checked = !checked;
    refreshDisplay();
    subcheckboxes.each((idx,subcheckbox)=>{
      $(subcheckbox).prop("checked",checked).trigger('blur');
    })
  },false);
  refreshDisplay()
}
